import React, { useState } from "react";
import moment from "moment";
import { dayNumber } from "../../helpers";
import { getSmallIconForDaysType } from "../icon-days-type";
import { NoItemFound } from "../no-data-found";
import ModalMap from "../map-view-modal";
import ThumbnailLightbox from "../thumbnail-lightbox";
import GoogleMapComponent from "../google-map-component";
import DurationComponent from "../departure-arrival-duration";

const ItineraryListComponent = ({
  destinationIndex,
  itineraryData,
  daysData,
  mapRef
}) => {
  const [itineraryDayData, setItineraryDayData] = useState([]);
  const [showMapModal, setShowMapModal] = useState(false);
  const getItineraryDaysDetails = async (data) => {
    setItineraryDayData(data);
    setShowMapModal(true);
  };

  // console.log(itineraryData)
  return (
    <>
      <div className="civ-item-bx">
        <div className="civ-day-date d-flex justify-content-between">
          <div>
            <span className="civ-day-txt">
              Day{" "}
              {destinationIndex > 0
                ? dayNumber(destinationIndex, daysData?.day, itineraryData)
                : daysData?.day}
            </span>
            <span>{moment(daysData?.date).format("DD MMMM yyyy")}</span>
          </div>
          {daysData?.itineraryDaysDetails?.length > 0 && (
            <button
              type="button"
              className="btn btn-secondary-color"
              onClick={() =>
                getItineraryDaysDetails(daysData?.itineraryDaysDetails)
              }
            >
              <i className="bi bi-geo-alt"></i>
            </button>
          )}
        </div>
        {daysData?.itineraryDaysDetails?.length > 0 ? (
          <div className="civ-list-row">
            {daysData?.itineraryDaysDetails
              ?.sort((a, b) => (a.time > b.time ? 1 : -1))
              .map((item, dt) => {
                return (
                  <>
                    <div className="civ-list-item" key={dt}>
                      <div className="civ-item-top-flex">
                        <ThumbnailLightbox thumbnails={item?.icon} data={item} />
                        <div className="civ-item-info">
                          <div className="civ-item-icon-check">
                            <span>
                              <img
                                src={getSmallIconForDaysType(
                                  item?.days_type,
                                  item?.types[0]
                                )}
                                alt={item?.days_type || "Icon"}
                                width={12}
                              />
                              {item?.days_type === "Transports"
                                ? item?.types[0]
                                : item?.days_type}
                            </span>
                          </div>
                          <h5>{item?.name}</h5>
                          {item?.amount === undefined || item?.amount === null ? (
                            "N/A"
                          ) : (
                            <p className="civ-item-price">
                              {item?.currency} {item?.amount}
                            </p>
                          )}
                          <p className="civ-time-count"><DurationComponent item={item} /></p>
                          {item?.websiteLink && (
                            <a
                              href={item?.websiteLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="link-text"
                            >See Details</a>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        ) : (
          <NoItemFound />
        )}
      </div>

      {showMapModal && <ModalMap open={showMapModal} onClose={setShowMapModal} days={itineraryDayData} />}
      {/* <div style={{ padding: 20, backgroundColor: "#E2F1FA", borderRadius: "10px", position: "absolute", left:0, top:0, right:0, zIndex:-2 }} ref={mapRef}>
        <GoogleMapComponent
          days={daysData?.itineraryDaysDetails}
          mapContainerStyle={{
            width: "100%",
            height: "500px",
          }}
          options={{
            streetViewControl: false,
            zoomControl: false,
            fullscreenControl: false,
            mapTypeControl: false
          }}
        />
      </div> */}
    </>
  );
};

export default ItineraryListComponent;
